export default __webpack_public_path__ + "static/media/stone_click.098ae0bf.mp3";